"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AppSettings_1 = tslib_1.__importDefault(require("./AppSettings"));
var axios_1 = tslib_1.__importDefault(require("axios"));
var AbilityService_1 = require("./AbilityService");
var SecureAxiosInstance = /** @class */ (function () {
    function SecureAxiosInstance() {
    }
    Object.defineProperty(SecureAxiosInstance.prototype, "Instance", {
        get: function () {
            var _this = this;
            var axiosConfig = { baseURL: AppSettings_1.default.dataProviderUrl };
            this.secureAxiosInstance = axios_1.default.create(axiosConfig);
            this.secureAxiosInstance.interceptors.request.use(function (config) {
                return new Promise(function (resolve, reject) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var token;
                    return tslib_1.__generator(this, function (_a) {
                        token = AbilityService_1.AbilityService.getAccessToken();
                        if (!!token) {
                            config.headers.Authorization = "Bearer " + token;
                            if (AppSettings_1.default.authScheme === "AbilityB2C") {
                                config.headers["X-Tenant"] = AbilityService_1.AbilityService.getTenant();
                            }
                            resolve(config);
                        }
                        else {
                            reject(config);
                        }
                        return [2 /*return*/];
                    });
                }); });
            }, function (error) {
                return Promise.reject(error);
            });
            return this.secureAxiosInstance;
        },
        enumerable: true,
        configurable: true
    });
    return SecureAxiosInstance;
}());
var secureAxiosInstance = new SecureAxiosInstance();
exports.default = secureAxiosInstance;
//# sourceMappingURL=SecureAxiosInstance.js.map